// Member/company API service 
import apiClient from './api';

export default {
  /**
   * Get all members/companies with optional filtering
   * @param {Object} params - Query parameters for filtering
   * @returns {Promise} - Axios promise
   */
  getMembers(params = {}) {
    return apiClient.get('/companies/', { params });
  },
  
  /**
   * Get a specific member/company by ID
   * @param {Number|String} id - Company ID
   * @returns {Promise} - Axios promise
   */
  getMember(id) {
    return apiClient.get(`/companies/${id}/`);
  },
  
  /**
   * Get projects associated with a specific company
   * @param {Number|String} id - Company ID
   * @returns {Promise} - Axios promise
   */
  getMemberProjects(id) {
    return apiClient.get(`/companies/${id}/projects/`);
  },
  
  /**
   * Filter members by service type or other criteria
   * @param {Object} filters - Object containing filter criteria
   * @returns {Promise} - Axios promise
   */
  filterMembers(filters = {}) {
    return apiClient.get('/companies/', { params: filters });
  },
  
  /**
   * Get featured members (companies marked as featured)
   * @returns {Promise} - Axios promise
   */
  getFeaturedMembers() {
    return apiClient.get('/companies/', { params: { is_featured: true } });
  },
  
  /**
   * Search members by name or description
   * @param {String} query - Search query
   * @returns {Promise} - Axios promise
   */
  searchMembers(query) {
    return apiClient.get('/companies/', { params: { search: query } });
  }
}; 